"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
const React = __importStar(require("react"));
const Pagination = (props) => {
    const { currentPage, totalPages } = props;
    return (React.createElement("div", { style: { width: '100%' } },
        React.createElement("ul", { className: "page-pagination" },
            React.createElement(PrevButton, { isNavBackDisabled: currentPage < 2, navigateBack: props.navigateBack }),
            React.createElement("li", { className: "current" }, props.pageStatusString),
            React.createElement(NextButton, { isNavNextDisabled: currentPage >= totalPages, navigateNext: props.navigateNext }))));
};
exports.Pagination = Pagination;
const PrevButton = (props) => {
    if (props.isNavBackDisabled) {
        return (React.createElement("li", { className: "prev disabled" },
            React.createElement("div", { className: "prev disabled" }, "\u00A0")));
    }
    return (React.createElement("li", { className: "prev" },
        React.createElement("div", { className: "prev", onClick: props.navigateBack }, "\u00A0")));
};
const NextButton = (props) => {
    if (props.isNavNextDisabled) {
        return (React.createElement("li", { className: "next disabled" },
            React.createElement("div", { className: "next disabled" }, "\u00A0")));
    }
    return (React.createElement("li", { className: "next" },
        React.createElement("div", { className: "next", onClick: props.navigateNext }, "\u00A0")));
};
//# sourceMappingURL=Pagination.js.map